import CatalogSwiper from '~/src/common/components/CatalogSwiper';
import CardDispatcher from '~/src/common/components/ProductsGrid/CardDispatcher';
import { sendCardEventClick } from '~/src/common/utils/product';
import { useCartRelatedArticles } from '~/src/queries/api-ecom/generated/api-ecom';
import { CartRelatedArticlesContext } from '~/src/queries/api-ecom/generated/api-ecom.schemas';
import { ProductPlaceholder } from '~/src/screens/CatalogContent/ListProductsScreen/layout';

import * as S from './layout';

interface Props {
  className?: string;
  mode: Extract<CartRelatedArticlesContext, 'COMPLEMENTARY' | 'SIMILAR'>;
  articleId: string;
  title: string;
}

const eventSource: Record<Props['mode'], 'complementary cross sell' | 'similar cross sell'> = {
  COMPLEMENTARY: 'complementary cross sell',
  SIMILAR: 'similar cross sell',
};

export const ProductXSell = (props: Props) => {
  const query = useCartRelatedArticles({
    context: props.mode,
    articleId: props.articleId,
    nbRelatedArticles: 24,
  });

  const articles = query.data?.items ?? [];

  if (query.isLoading && query.data == null)
    return (
      <S.Root className={props.className}>
        <S.Title>{props.title}</S.Title>

        <CatalogSwiper>
          {Array.from({ length: 6 }, (_, idx) => (
            <ProductPlaceholder key={idx} />
          ))}
        </CatalogSwiper>
      </S.Root>
    );

  if (query.data == null || articles.length === 0) return null;

  return (
    <S.Root className={props.className}>
      <S.Title>{props.title}</S.Title>

      <CatalogSwiper>
        {articles.map(article => (
          <CardDispatcher
            key={article.id}
            product={article}
            source={{
              type: eventSource[props.mode],
              detail: {
                initialSku: props.articleId,
                variantId: query.data.execution.variantId,
              },
            }}
            eventSource={eventSource[props.mode]}
            onRefresh={query.refetch}
            onClick={product => sendCardEventClick(articles, product, {})}
            analyticsProperties={{
              'number of products in the list': articles.length,
              'number of cards in the list': articles.length,
            }}
          />
        ))}
      </CatalogSwiper>
    </S.Root>
  );
};
